//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../Features/Features.SheetMetal.SMBoundaryConditionBuilderList.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
import "../no/ObjectList.js";
let d=[[[1,"AngularTolerance",0,"Expression",0],[1,"ChordalTolerance",0,"Expression",0],[1,"ElasticModulus",0,"Expression",0],[1,"EndRegion",0,"ScCollector",0],[1,"HoleRemovalMinModulus",0,"Expression",0],[0,"InferThickness",1,0],[1,"LinearTolerance",0,"Expression",0],[1,"NeutralFactor",0,"Expression",0],[0,"OutputLayer",1,0],[1,"PoissonsRatio",0,"Expression",0],[1,"RValue",0,"Expression",0],[0,"RemoveHoles",1,0],[0,"ReverseThicknessDirection",1,0],[1,"SMBoundaryConditions",0,"Features.SheetMetal.SMBoundaryConditionBuilderList",0],[1,"StartRegion",0,"ScCollector",0],[1,"TangentModulus",0,"Expression",0],[1,"Thickness",0,"Expression",0],[1,"TransformGeometry",0,"SelectNXObjectList",0],[1,"YieldStress",0,"Expression",0]],[[[],"CreateSMBoundaryCondition",{R_:{listitem:"Features.SheetMetal.SMBoundaryConditionBuilder"}},0,0]],[]];
SPLM.Features.SheetMetal.MetaformBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.MetaformBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;